import { Injectable } from "@angular/core";
import { addHours, parseISO } from "date-fns";

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    constructor() {
    }

    save(key: string, value: any) {
        sessionStorage.setItem(key, JSON.stringify({ date: new Date(), value }));
    }

    retrieve<T>(key: string): T | null {
        const entry = sessionStorage.getItem(key);
        if (!entry) return null;
        const { date, value } = JSON.parse(entry);
        if (parseISO(date) > addHours(new Date(), -1))
            return value;
        return null;
    }

    saveAnswers(questionnaire: string, data: { key: string, answers: { [key: string]: string } }) {
        this.save(`Answers:${questionnaire}`, data);
    }

    getAnswers(questionnaire: string): { key: string, answers: { [key: string]: string } } | null {
        return this.retrieve(`Answers:${questionnaire}`);
    }
}